import { persistStore, persistReducer } from 'redux-persist';
import { configureStore } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import storage from 'redux-persist/lib/storage';

import { PREFIX_STORE } from '../constants/localstorage';
import Reducers from './reducers';

const persistConfig = {
  key: PREFIX_STORE,
  storage,
  blacklist: ['globalReducer', 'foilReducer', 'catalogReducer'],
};

const persistedReducer = persistReducer(persistConfig, Reducers);

const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});

const persistor = persistStore(store);

const storeConfig = { store, persistor };

export default storeConfig;

// Infiere los tipos de `RootState` y `AppDispatch` desde el propio store
export type RootState = ReturnType<typeof store.getState>;
// Creamos el tipo para dispatch tomandolo del store
export type AppDispatch = typeof store.dispatch;
